<div class="dashboard-detail-grid-modal">
    <div class="dashboard-detail-grid-modal-header">
        <div class="dashboard-detail-grid-modal-header-top">
            <div class="dashboard-detail-grid-modal-header-title">
                {{ tile.dashboardTileName | titlecase }}{{ item?.itemName ? (': ' + item?.itemName) : ''}}
                <span class="dashboard-detail-grid-modal-header-record"> - {{ totalItems }} records</span>
            </div>
            <button mat-dialog-close class="dashboard-detail-grid-modal-close-top">
                <i class="fas fa-times dashboard-detail-grid-modal-close"></i>
            </button>
        </div>
        <div class="dashboard-detail-grid-modal-header-bottom">
            <div class="dashboard-detail-grid-modal-divider"></div>
        </div>
    </div>
    <app-ag-grid [data]="tileData" [headers]="headers" [height]="510" [pagination]="false" #grid>
    </app-ag-grid>
    <div class="dashboard-detail-grid-modal-footer">
        <button class="dashboard-detail-grid-modal-btn-export" (click)="onButtonExport()"> 
            <i class="fal fa-file-excel dashboard-detail-grid-modal-export"></i> 
            <span class="dashboard-detail-grid-modal-btn-export-text">Export to Excel</span>
        </button>
        <button mat-dialog-close mat-stroked-button class="dashboard-detail-grid-modal-close-bottom">
            CLOSE
        </button>
    </div>
</div>